export enum PricingImpoundType {
  'Tax and insurance escrow' = 0,
  'Tax escrow only' = 1,
  'Insurance escrow only' = 2,
  'No escrow' = 3
}

export enum PricingImpoundTypeText {
  TAX_AND_INSURANCE_ESCROW = 'Tax and insurance escrow',
  TAX_ESCROW_ONLY = 'Tax escrow only',
  INSURANCE_ESCROW_ONLY = 'Insurance escrow only',
  NO_ESCROW = 'No escrow'
}